import { Injectable, inject } from '@angular/core';
import { IQueryParamItem, IQueryParams, QueryStringType } from '@sirius/common';
import { API_URL } from '../tokens';

@Injectable({
    providedIn: 'root',
})
export class UrlService {
    private _baseUrl = inject(API_URL);


    buildApiUrl(url: string, params: string): string {
        const tempUrl = this._baseUrl || 'https://tempUrl.com';
        const fullUrl = new URL(`${tempUrl}${url}${params}`);

        fullUrl.searchParams.set('asjson', '1');

        const pathName = fullUrl.pathname || '';
        const search = fullUrl.search || '';
        const relativePath = '.' + pathName + search;

        return this._baseUrl.length > 0 ? fullUrl.toString() : relativePath;
    }

    toQueryParams(paramString: string): IQueryParams[] {
        const paramsArr = paramString.split('&');
        const queryParamsArr: IQueryParams[] = paramsArr.map((x: string) => {
            const query = x.split('=');
            const queryString = query[0] as QueryStringType;
            const paramsString = query[1];
            const params = paramsString.split(';');
            const queryParams: IQueryParams = {
                queryString: queryString,
                params: [],
            };

            params.forEach((y: string) => {
                const paramArr = y.split(':');
                let paramItem: IQueryParamItem = { value: paramArr[0] };

                if (paramArr.length > 1) {
                    paramItem = { id: paramArr[0], value: paramArr[1] };
                }

                queryParams.params.push(paramItem);
            });

            return queryParams;
        });

        return queryParamsArr;
    }

    toStringParams(queries: IQueryParams[]): string {
        if (!queries.length) {
            return '';
        }

        const paramsList: string[] = [];
        queries.forEach((x: IQueryParams) => {
            const queryString = x.queryString;
            const queryParams: string[] = [];

            x.params.forEach((y: IQueryParamItem) => {
                // First decode query parameter, to ensure no double encoding will take place
                let field = decodeURIComponent(y.value);

                if (y.id) {
                    field = `${y.id}:${field}`;
                }

                queryParams.push(field);
            });

            for (let i = 1; i < x.params.length; i++) {
                queryParams[i] = ';' + queryParams[i];
            }

            paramsList.push(queryString + '=' + encodeURIComponent(queryParams.join('')));
        });

        for (let i = 1; i < paramsList.length; i++) {
            paramsList[i] = '&' + paramsList[i];
        }

        return '?' + paramsList.join('');
    }

    segmentUrl(url: string): { locationStr: string; queryParamsStr: string; fragmentStr: string } {
        const splitByQueryParams = url.split('?');
        const splitByFragment = url.split('#');
        const location = splitByFragment[0].split('?')[0];
        const queryParams =
            splitByQueryParams.length > 1 ? splitByQueryParams[1].split('#')[0] : '';
        const fragment = splitByFragment.length > 1 ? splitByFragment[1] : '';

        return { locationStr: location, queryParamsStr: queryParams, fragmentStr: fragment };
    }
}
